import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
        const userToken = localStorage.getItem('authorization');
        return userToken
    };

    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        localStorage.setItem('authorization', userToken);
        setToken(userToken);
    };

    // Fungsi untuk menghapus token dari localStorage dan update state
    const deleteToken = () => {
        localStorage.removeItem('authorization');
        setToken(null);
    };

    // Mengembalikan state token dan fungsi untuk menyetelnya serta menghapusnya
    return {
        setToken: saveToken,
        deleteToken,
        token
    };

}